import axios from 'axios';
import { useEffect, useState } from 'react';
import type { RibeyePublisher } from '../lib/publisherInventory';

/**
 * The Ribeye Publisher directory (flank#4643) — `GET /publishers`
 * (ribeye-api `PublishersController` -> `BeeswaxPublisherService
 * .getPublishersWithBundles`), scoped server-side to the whitelabel's
 * Beeswax seat. `{id, name, logo, bundles}` per publisher; a change to a
 * mapping in Directus shows up here with no flank code change, since this
 * always reads live rather than caching across mounts.
 */
export const usePublishersDirectory = (enabled = true) => {
  const [publishers, setPublishers] = useState<RibeyePublisher[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    setLoading(true);
    axios
      .get<RibeyePublisher[]>('/publishers')
      .then(res => {
        if (active) {
          setPublishers(res.data ?? []);
          setError(null);
        }
      })
      .catch(() => {
        if (active) setError("Couldn't load the Publisher directory.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [enabled]);

  return { publishers, loading, error };
};
